import { useRef, useEffect } from 'react';

/**
 * Relocates an ESI container (rendered outside #productRoot by the server)
 * into a React-managed placeholder after hydration. This keeps ESI-expanded
 * content out of React's reconciliation tree so that hydration mismatches
 * (e.g. from HTML minification) cannot clobber it.
 */
export default function useEsiPortal(esiId: string): React.RefObject<HTMLDivElement> {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const esiNode = document.getElementById(esiId);
    if (!esiNode || !ref.current) return;

    ref.current.appendChild(esiNode);
    esiNode.hidden = false;
  }, [esiId]);

  return ref;
}
